import httpService from "./httpService";

export default {
  registerCompany: async company => httpService.post(`/companyRegistration`, company)
};
